import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Star, Shield, Trophy, ArrowRight, BookOpen, Palette, Music, Heart } from 'lucide-react';
import { IMAGES } from '../utils/constants';

const Home = () => {
  // const stats = [
  //   { label: "Happy Students", value: "2000+", icon: <Users size={24} /> },
  //   { label: "Expert Teachers", value: "50+", icon: <Star size={24} /> },
  //   { label: "Years Experience", value: "12+", icon: <Shield size={24} /> },
  //   { label: "Awards Won", value: "15+", icon: <Trophy size={24} /> },
  // ];

  const features = [
    { title: "Play & Learn", desc: "Interactive learning through play-based activities.", icon: <BookOpen className="text-secondary" size={32} /> },
    { title: "Creative Arts", desc: "Expressing imagination through colors and crafts.", icon: <Palette className="text-accent" size={32} /> },
    { title: "Music & Dance", desc: "Rhythm and movement for physical development.", icon: <Music className="text-primary" size={32} /> },
    { title: "Safe Environment", desc: "CCTV monitored safe and secure campus.", icon: <Shield className="text-success" size={32} /> },
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container hero-container">
          <div className="hero-content">
            <span className="hero-badge">Admissions Open</span>
            <h1 className="hero-title">
              Where <span className="text-primary">Little Stars</span> <br />
              Shine the Brightest
            </h1>
            <p className="hero-desc">
              We provide a nurturing environment where children discover, explore, and learn.
              Join the leading preschool family today.
            </p>
            <div className="hero-btns">
              <Link to="/contact" className="btn btn-primary">Enroll Now</Link>
              <Link to="/about" className="btn btn-outline">Learn More</Link>
            </div>
          </div>
          <div className="hero-image-wrapper">
            <div className="hero-blob"></div>
            <img
              src={IMAGES.hero}
              alt="Happy Kids Learning"
              className="hero-img"
            />
          </div>
        </div>
      </section>

      {/* Stats Section */}
      {/* <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            {stats.map((s, i) => (
              <div key={i} className="stat-card">
                <div className="stat-icon">{s.icon}</div>
                <div className="stat-value">{s.value}</div>
                <div className="stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* About Section */}
      <section className="section bg-white">
        <div className="container grid grid-cols-2 mobile-stack">
          <div className="about-img-group">
            <img src={IMAGES.homeAbout1} alt="Kids Playing" className="about-img-1" />
            <img src={IMAGES.homeAbout2} alt="Classroom" className="about-img-2" />
          </div>
          <div className="about-content">
            <h2 className="section-title">Welcome to Little Star Kids Academy</h2>
            <p className="section-desc">
              At Little Star, we focus on developing better standards of curriculum and constantly
              updating newer methods to improve the kids' schooling experience. Our goal is to
              create a second home for your child where learning is natural and fun.
            </p>
            <ul className="feature-list">
              <li>
                <Heart size={20} className="text-accent" />
                <span>Nurturing & Caring Environment</span>
              </li>
              <li>
                <Star size={20} className="text-secondary-dark" />
                <span>Innovative Curriculum</span>
              </li>
              <li>
                <Shield size={20} className="text-success" />
                <span>Safety First Priority</span>
              </li>
            </ul>
            <Link to="/about" className="btn btn-secondary mt-6">Read More About Us</Link>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="section bg-subtle">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="section-title">Why Choose Us?</h2>
            <p className="section-subtitle">We offer the best facilities for your child's holistic growth.</p>
          </div>
          <div className="features-grid">
            {features.map((f, i) => (
              <div key={i} className="feature-card">
                <div className="feature-icon-wrapper">{f.icon}</div>
                <h3 className="feature-title">{f.title}</h3>
                <p className="feature-text">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <style>{`
        .bg-subtle { background-color: var(--color-bg-light); }
        .bg-white { background-color: white; }

        .hero-section {
          padding: 4rem 0 6rem;
          background: linear-gradient(180deg, rgba(99, 102, 241, 0.05) 0%, transparent 100%);
          overflow: hidden;
        }

        .hero-container {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 4rem;
          align-items: center;
        }

        .hero-badge {
          display: inline-block;
          background-color: rgba(252, 211, 77, 0.3);
          color: #b45309;
          font-weight: 600;
          padding: 0.5rem 1rem;
          border-radius: 2rem;
          margin-bottom: 1.5rem;
          font-size: 0.875rem;
        }

        .hero-title {
          font-size: 3.5rem;
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 1.5rem;
          color: var(--color-text-main);
        }

        .hero-desc {
          font-size: 1.125rem;
          color: var(--color-text-light);
          margin-bottom: 2.5rem;
          max-width: 500px;
        }

        .hero-btns {
          display: flex;
          gap: 1rem;
        }

        .hero-image-wrapper {
          position: relative;
        }

        .hero-blob {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 500px;
          height: 500px;
          background-color: var(--color-secondary);
          opacity: 0.2;
          border-radius: 50%;
          filter: blur(60px);
          z-index: -1;
        }

        .hero-img {
          width: 100%;
          border-radius: 2rem;
          transform: rotate(2deg);
          box-shadow: var(--shadow-xl);
          border: 4px solid white;
        }

        /* Stats */
        .stats-section {
          margin-top: -3rem;
          margin-bottom: 4rem;
          position: relative;
          z-index: 10;
        }

        .stats-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 2rem;
          background: white;
          padding: 3rem;
          border-radius: 2rem;
          box-shadow: var(--shadow-lg);
        }

        .stat-card {
          text-align: center;
          display: flex;
          flex-col: column;
          align-items: center;
          gap: 0.5rem;
        }

        .stat-icon {
          color: var(--color-primary);
          margin-bottom: 0.5rem;
        }

        .stat-value {
          font-size: 2.5rem;
          font-weight: 800;
          color: var(--color-text-main);
        }

        .stat-label {
          font-weight: 600;
          color: var(--color-text-light);
          text-transform: uppercase;
          font-size: 0.75rem;
          letter-spacing: 0.05em;
        }

        /* About & Features */
        .mobile-stack {
          align-items: center;
        }

        .about-img-group {
          position: relative;
          height: 500px;
        }

          .about-img-1 {
            position: absolute;
            top: 0;
            left: 0;
            width: 70%;
            height: 60%;
            object-fit: cover;
            border-radius: 2rem;
            border: 4px solid white;
            box-shadow: var(--shadow-xl);
            z-index: 1;
          }

          .about-img-2 {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 60%;
            height: 60%;
            object-fit: cover;
            border-radius: 2rem;
            border: 4px solid white;
            box-shadow: var(--shadow-xl);
            z-index: 2;
          }

        .section-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: var(--color-text-main);
        }

        .section-desc {
          color: var(--color-text-light);
          margin-bottom: 2rem;
          font-size: 1.1rem;
        }

        .section-subtitle {
          color: var(--color-text-light);
          font-size: 1.1rem;
        }

        .feature-list li {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1rem;
          font-weight: 500;
          font-size: 1.1rem;
        }

        .features-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 2rem;
        }

        .feature-text {
          color: var(--color-text-light);
        }

        .feature-card {
          background: white;
          padding: 2rem;
          border-radius: 1.5rem;
          text-align: center;
          box-shadow: var(--shadow-sm);
          transition: 0.3s;
          border: 1px solid #f1f5f9;
        }

        .feature-card:hover {
          transform: translateY(-5px);
          box-shadow: var(--shadow-lg);
          border-color: var(--color-primary-light);
        }

        .feature-icon-wrapper {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          background: var(--color-bg-light);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
        }

        @media (max-width: 960px) {
          .hero-container, .mobile-stack {
            grid-template-columns: 1fr;
            text-align: center;
          }

          .hero-btns, .feature-list li, .about-content {
            justify-content: center;
            align-items: center;
          }
          
          .feature-list li {
            justify-content: flex-start; /* Keep list aligned if needed, or center */
            display: inline-flex;
            margin: 0.5rem;
          }

          .about-img-group {
            height: 400px;
            margin-bottom: 3rem;
          }
          
          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          
          .features-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 640px) {
          .hero-title { font-size: 2.5rem; }
          .stats-grid { grid-template-columns: 1fr; }
          .features-grid { grid-template-columns: 1fr; }
        }
      `}</style>
    </div>
  );
};

export default Home;
